import React from 'react'

import Tool from '~/models/tool'

import RowList from '~/components/atoms/row/RowList'
import ToolRow from '~/components/app/modules/tool/list/ToolRow'
import { RowBaseLayoutSize } from '~/components/molecules/row/content/RowBaseLayout'

interface Props {
  tools: Tool[]
  size?: RowBaseLayoutSize
}

const ToolList = ({tools, size = null}: Props) => {
  return (
    <RowList>
      {tools.map((tool: Tool) =>
        <ToolRow key={tool.id} tool={tool} size={size}/>
      )}
    </RowList>
  )
}

export default ToolList